// Normalise any axios/fetch error into a plain string safe to render.
// FastAPI 422s return `detail` as an array of {loc,msg,...}; quota/plan
// gates return a dict with `message` — neither may be passed to toast/JSX.
export function errMsg(e, fallback = 'Something went wrong.') {
  const d = e?.response?.data?.detail ?? e?.response?.data?.message;
  if (typeof d === 'string' && d.trim()) return d;
  if (Array.isArray(d)) {
    const first = d.find(x => x && typeof x === 'object') || d[0];
    if (first && typeof first === 'object') {
      const field = Array.isArray(first.loc) ? first.loc.filter(l => l !== 'body').join('.') : '';
      return `${field ? field + ': ' : ''}${first.msg || fallback}`;
    }
    if (typeof first === 'string') return first;
  }
  if (d && typeof d === 'object') return d.message || d.detail || fallback;
  if (typeof e?.message === 'string' && e.message && !/^Request failed/i.test(e.message)) return e.message;
  return fallback;
}
